<script setup lang="ts">
import vueRecaptcha from 'vue3-recaptcha2';
import ModalMessages from '../../components/Modais/ModalMessages.vue'
</script>
<template>
  <h3 class="mt-2">
    {{ translate.contactTitle }}
  </h3>
  <form @submit="onSubmit" @reset="onReset">
    <div class="mb-3">
      <input
        type="text"
        class="form-control"
        v-model="form.name"
        id="input-name"
        :placeholder=translate.contactName
        aria-describedby="nameHelp"
      />
    </div>
    <div class="mb-3">
      <input
        type="email"
        class="form-control"
        v-model="form.email"
        id="input-email"
        :placeholder=translate.contactMail
        aria-describedby="emailHelp"
      />
    </div>
    <div class="mb-3">
      <input
        type="telefone"
        class="form-control"
        v-model="form.phone"
        id="input-telefone"
        placeholder="(xx) 9xxxx-xxxx"
        v-maska
        data-maska="(##) #####-####"
        aria-describedby="telefoneHelp"
      />
    </div>
    <select class="form-select" aria-label="Default select example" v-model="form.category">
      <option disabled value="">{{ translate.category0 }}</option>
      <option v-for="{ value, name } in categories" :key="value" :value="value">{{ name }}</option>
    </select>
    <div class="mb-3">
      <input
        type="text"
        class="form-control"
        v-model="form.login"
        id="input-login"
        :placeholder=translate.contactLogin
        aria-describedby="loginHelp"
      />
    </div>
    <div class="mb-3">
      <input
        type="text"
        class="form-control"
        v-model="form.subject"
        id="input-subject"
        :placeholder=translate.contactSubject
        aria-describedby="subjectHelp"
      />
    </div>
    <div class="mb-3">
      <textarea
        rows="3"
        class="form-control"
        v-model="form.message"
        id="input-message"
        :placeholder=translate.contactMessage
        aria-describedby="messageHelp"
      ></textarea>
    </div>
    <div class="d-flex justify-content-center">
      <vue-recaptcha ref="red" v-if="showRecaptcha" :sitekey="recaptchaSiteKey"
        v-on:verify="recaptchaUpdated" hl="pt-br"></vue-recaptcha>
    </div>
    <div class="d-flex justify-content-center py-3">    
      <button class="d-w-btn" type="submit">{{ translate.contactButton }} <i class="icon-arrow-right"></i></button>
    </div>    
    <br><br><br>    
  </form>
  <ModalMessages @showModalMessages="showModalMessages" :options="options" />    
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import api from '../../api'  
  import { localeStore } from 'stores/locale'  
  import { mapState } from 'pinia'  
  import tradutor from 'tradutors/contact'  

  export default defineComponent({
    name: 'FaqContact',
    components: {
        vueRecaptcha
    },
    computed: {
        ...mapState(localeStore, ['locale']),
        translate: function () {
            if (this.locale === 'pt-br') {
                return tradutor.portugues
            } else {
                return tradutor.ingles
            }
        }
    },
    data() {
      return {
        form: {
          name: '',          
          email: '',
          subject: '',
          message: '',
          phone: '',
          category: '',
          login: ''
        },
        showRecaptcha: true,
        recaptcha: null,
        recaptchaSiteKey: '6LcqxykUAAAAADAOWqu2zCV2_uaW1IMDzoiKfn5J',
        options: {
          showModal: false,
          titleModal: '',
          textBodyModal: '',
          textButtonModal: ''
        },
        categories: []
      }
    },
    watch: {
      'locale': function () {
        this.categories = [
          { value: 1, name: this.translate.category1 },
          { value: 2, name: this.translate.category2 },
          { value: 3, name: this.translate.category3 },
          { value: 4, name: this.translate.category4 },
          { value: 5, name: this.translate.category5 },
          { value: 6, name: this.translate.category6 }
        ]
      }
    },    
    mounted() {
      this.categories = [
          { value: 1, name: this.translate.category1 },
          { value: 2, name: this.translate.category2 },
          { value: 3, name: this.translate.category3 },
          { value: 4, name: this.translate.category4 },
          { value: 5, name: this.translate.category5 },
          { value: 6, name: this.translate.category6 }
        ]
    },
    methods: {
      recaptchaExpired() {
          this.$refs.red.reset();
      },
      recaptchaUpdated(recaptcha) {
          this.recaptcha = recaptcha;
      },
      onSubmit(event) {
        event.preventDefault()
        let form = {
          contact_name: this.form.name,
          contact_email: this.form.email,
          contact_subject: this.form.subject,
          contact_message: this.form.message,
          contact_phone: this.form.phone,
          contact_category: this.form.category,
          contact_login: this.form.login,
          language: this.locale ?? 'pt-br'
        }
        form['g-recaptcha-response'] = this.recaptcha
        if (!this.recaptcha)
          return this.showModalMessages({ message: { show: true, title: this.translate.msgTitle1, textButton: this.translate.msgClose, textBoby: this.translate.fillRecaptcha } })

        api.post('v1/contact/sendContactApi', form)
            .then(({ data }) => {
              if (data.message == "success") {
                data.message = this.translate.msgSuccess
                this.form.name = ''
                this.form.email = ''
                this.form.subject = ''
                this.form.message = ''
                this.form.phone = ''
                this.form.category = ''
                this.form.login = ''
                this.recaptchaExpired()                
              }
              this.showModalMessages({ message: { show: true, title: this.translate.msgTitle2, textButton: this.translate.msgClose, textBoby: data.message } })
            }).catch(() => {
              this.showModalMessages({ message: { show: true, title: this.translate.msgTitle1, textButton: this.translate.msgClose, textBoby: this.translate.failSend } })
            })
      },
      showModalMessages(data) {
        this.options.showModal = data.message.show
        this.options.titleModal = data.message.title
        this.options.textBodyModal = data.message.textBoby
        this.options.textButtonModal = data.message.textButton
      },
      onReset(event) {
        event.preventDefault()
        // Reset our form values
        this.form = {
          name: '',          
          email: '',
          subject: '',
          message: '',
          phone: '',
          category: '',
          login: ''
        }
      }
    }
  })
</script>

<style lang="css" scoped>
  h3 {
    font-size: medium;
    font-family: 'Exo-2';
    color: black;
  }

  .form-control {
    background-color: #f2f2f2;
    border: 1px solid #ccc;
    color: #747474;
    margin: 8px 5px;
    padding: 10px;
    font-size: 14px;
    border-radius: 30px;
  }

  .form-select {
    background-color: #f2f2f2;
    border: 1px solid #ccc;
    color: #747474;
    margin: 8px 5px;
    padding: 10px;
    font-size: 14px;
    border-radius: 30px;
  }
  .d-w-btn {
    color: #fff;
    padding: 17px 30px;
    background: #000;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Exo-2';
  }
</style>
